import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.tsx';
import LockedPage from '../pages/LockedPage.tsx';

// ─── LockGate — client-side half of the v143 app-wide access lock ─────────────────────────────
// Sits between ProtectedRoute and AppLayout in App.tsx. A locked non-admin sees LockedPage instead
// of the app shell (no Sidebar/TopBar, no Outlet content) for every path EXCEPT /billing, which
// must stay reachable through the shell so BillingPage's own facility-picker/self-checkout UI keeps
// working -- this exactly mirrors the server's own exemption list in
// server/src/middleware/auth.ts (LOCK_EXEMPT_PREFIXES includes /api/billing/). Admin is never
// locked (server never even computes lock:true for that role -- see auth.ts), so this is really only
// reachable for org_admin/manager/user/viewer.
export default function LockGate({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const location = useLocation();

  const isLocked = !!user?.locked && user.role !== 'admin';
  const onBillingRoute = location.pathname === '/billing';

  if (isLocked && !onBillingRoute) {
    return <LockedPage />;
  }

  return <>{children}</>;
}
